import { leanEntries } from "Constants/defaultStyles";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import ExitButton from "../Atoms/ExitButton";

export default function SidePage({
  onClose,
  children,
}: {
  onClose: () => void;
  children: React.ReactNode;
}) {
  // TODO: why do we even need this?
  const [_, setScreenSize] = useState(window.innerWidth);
  const [_b, setMouseOver] = useState(false);
  useEffect(() => {
    function handleResize() {
      setScreenSize(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <motion.div
      className={"mt-26 absolute z-20 h-[100vh] w-[22vw] "}
      initial={{ x: "100vw" }}
      animate={{ x: "80vw" }}
      transition={{ type: "spring", damping: 30 }}
      style={{ background: leanEntries.color2 }}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="mt-40 flex flex-row justify-between">
        <div className="mr-12 md:mr-8 ">
          <ExitButton onClick={onClose} />
        </div>
      </div>

      <div className="  ml-1 h-4/5   !overflow-y-scroll">
        <div className={"w-[20vw] "}>{children}</div>
      </div>
    </motion.div>
  );
}
